import { GuestPass } from "@/components/GuestPasses";
import { HistoricalGuestPass } from "@/components/GuestPasses/GuestPassHistory";
import { ShareType } from "@/components/GuestPasses/GuestPassShareModal";
import { fetchJSONFactory } from "@/utils/fetch-json";

export const fetchJSON = fetchJSONFactory(import.meta.env.VITE_FINANCE_API);

export type FetchUserGuestPassesResponse = GuestPass[];

export const urlSuffix = "/users/guest-passes";

export const fetchUserGuestPasses = async () => {
  return fetchJSON<FetchUserGuestPassesResponse>(urlSuffix, {
    method: "GET",
  });
};

export type CreateGuestPassesShareLinkResponse = {
  shareLink: string;
  shareCopyableText: string;
};

export const createGuestPassShareLink = async (id: number) => {
  return await fetchJSON<CreateGuestPassesShareLinkResponse>(
    "users/guest-pass-link",
    {
      body: { parentCouponCodeId: id },
      method: "POST",
    },
  );
};

export type ShareGuestPassParams = {
  parentCouponCodeId: number;
  channel: {
    type: ShareType;
    email?: string;
    sms?: string;
  };
  firstName: string;
  lastName: string;
};

export type ShareGuestPassResponse = {
  sucId: string;
};

export const shareGuestPass = async (params: ShareGuestPassParams) => {
  return fetchJSON<ShareGuestPassResponse>("users/send-guest-pass", {
    body: {
      parentCouponCodeId: params.parentCouponCodeId,
      channel: {
        type: params.channel.type,
        email: params.channel.email,
      },
      firstName: params.firstName,
      lastName: params.lastName,
    },
    method: "POST",
  });
};

export type FetchGuestPassHistoryResponse = {
  history: HistoricalGuestPass[];
};

export const fetchGuestPassHistory = async () => {
  return fetchJSON<FetchGuestPassHistoryResponse>("users/guest-pass-history", {
    method: "GET",
  });
};
